
import { supabase } from '@/integrations/supabase/client';

/**
 * Fetches dashboard data from Supabase storage with fallback handling
 */
export async function fetchDataWithFallback(fileName: string, fallback: any = {}) {
  try {
    console.log(`Fetching ${fileName} data...`);
    const response = await supabase.storage.from('dane').download(fileName);
    if (response.error) {
      console.warn(`Failed to load ${fileName}:`, response.error);
      return fallback;
    }

    const text = await response.data.text();
    console.log(`Successfully loaded ${fileName}, data length: ${text.length}`);

    try {
      const parsedData = JSON.parse(text);
      return parsedData;
    } catch (parseError) {
      console.error(`Error parsing JSON from ${fileName}:`, parseError);
      return fallback;
    }
  } catch (error) {
    console.warn(`Error processing ${fileName}:`, error);
    return fallback;
  }
}

/**
 * Fetches all data sources needed for the dashboard
 */
export async function fetchAllDashboardData(newsFileName: string = 'newsen.json') {
  console.log(`fetchAllDashboardData using news file: ${newsFileName}`);

  // Return a promise that fetches all data in parallel
  return Promise.all([
    fetchDataWithFallback('ddos-old.json', { targets: [] }),
    fetchDataWithFallback('leak.json', []),
    fetchDataWithFallback('ransomware.json', []),
    fetchDataWithFallback('2025.json', []),
    fetchDataWithFallback('ddos.json', { targets: [] }),
    fetchDataWithFallback(newsFileName, { items: [] }),
    fetchDataWithFallback('eol.json', {}),
    fetchDataWithFallback('releases.json', []),
  ]);
}
